import React, { useEffect, useState } from "react";
import { BiX } from "react-icons/bi";
import { MdAddCircle } from "react-icons/md";

import { useDialog } from "src/contexts/dialog-context";
import { useStudent } from "src/contexts/student";
import api from "src/rest/api";
import { twMerge } from "tailwind-merge";

const TabLayout: React.FC<{
  arr: string[];
  RemoveNote: (index: number) => void;
  AddNote: () => void;
}> = ({ arr, RemoveNote, AddNote }) => {
  const [selected, setSelected] = useState(0);
  const [tabs, setTabs] = useState(arr);
  const { student } = useStudent();

  useEffect(() => {
    setTabs(arr);
  }, [arr]);

  function handleBlur(newVal: string) {
    if (newVal !== tabs[selected]) {
      const newArr = [...tabs];
      newArr[selected] = newVal;
      UploadNote(newArr);
    }
  }

  function handleRemove(index: number) {
    setSelected(index);
    dialog.openDialog(
      "Remover Anotação",
      `Tem certeza que deseja remover anotação "NOTA ${index + 1}"?`,
      () => {
        setSelected(0);
        RemoveNote(index);
        setTabs([...tabs]);
      },
    );
  }

  const dialog = useDialog();

  function UploadNote(data: string[]) {
    console.log("uploading notes:", data);
    if (!student) return;
    api
      .post("/students/savenotes", {
        ref: student.id,
        data: data,
      })
      .then(() => {
        setTabs([...data]);
      })
      .catch((err) => {
        alert(err);
      });
  }

  const getTabLabel = (tab: string, index: number) => {
    if (tab && tab.trim().length > 0) {
      // Split by any whitespace, including line breaks
      return tab.trim().split(/\s+/)[0];
    }
    return `Nota ${index + 1}`;
  };

  return (
    <div className="relative flex flex-1 flex-row overflow-hidden">
      <div className="flex w-24 flex-col pr-2">
        <div className="flex w-full flex-1 flex-col overflow-y-auto">
          {tabs.map((item, index) => (
            <div
              key={`Note_${index}`}
              className={twMerge(
                "cursor-pointer",
                "flex items-center justify-between gap-1 overflow-clip text-ellipsis whitespace-nowrap rounded pr-1 transition-all hover:bg-zinc-50 hover:dark:bg-zinc-500",
                selected === index
                  ? "h-12 rounded-sm bg-zinc-200 text-black dark:bg-zinc-400"
                  : "h-7 bg-transparent text-white",
              )}
            >
              <button
                className="h-full w-10 flex-1 items-center overflow-clip pl-1"
                onClick={() => setSelected(index)}
              >
                <p
                  className={twMerge(
                    "text-ellipsis text-sm text-black",
                    tabs[index] === "" && "underline decoration-zinc-500",
                    selected === index ? "dark:text-black" : "dark:text-white",
                  )}
                >
                  {getTabLabel(tabs[index], index)}
                </p>
              </button>

              <button
                onClick={() => handleRemove(index)}
                className={twMerge(
                  selected === index ? "dark:text-black" : "dark:text-white",
                  "rounded-full text-zinc-800 hover:bg-red-500",
                )}
              >
                <BiX />
              </button>
            </div>
          ))}
        </div>
        <button
          className="mt-4 flex items-center justify-center rounded-md bg-primary-500 p-2"
          onClick={AddNote}
        >
          <MdAddCircle color="white" />
        </button>
      </div>
      <textarea
        key={`tab-${selected}`}
        defaultValue={tabs[selected]}
        placeholder={`Anotação ${selected + 1}...`}
        onBlur={(e) => handleBlur(e.target.value)}
        className="h-full flex-1 resize-none rounded border bg-transparent p-3 outline-none placeholder:italic focus:border-black dark:border-zinc-600 dark:text-white focus:dark:border-white"
      />
    </div>
  );
};

export default TabLayout;
